import { iconesMap } from './icones';

export function mapDomain(de: string) {
  let para = '';
  switch (de) {
    case 'Administração':
      para = 'Ações de governo';
      break;
    case 'Meio Ambiente':
      para = 'Ambiental';
      break;
    case 'Meio Ambiente e Urbanismo':
      para = 'Ambiental';
      break;
    case 'Desenvolvimento':
      para = 'Economia';
      break;
    case 'Esporte':
      para = 'Social';
      break;
    case 'Governança':
      para = 'Ações de governo';
      break;
    case 'Infraestrutura':
      para = 'Zeladoria';
      break;
    case 'Planejamento':
      para = 'Ações de governo';
      break;
    case 'Procuradoria':
      para = 'Ações de governo';
      break;
    case 'Segurança':
      para = 'Social';
      break;
    case 'Transparência':
      para = 'Ações de governo';
      break;
    case 'Dados Abertos':
      para = 'Ações de governo';
      break;
    case '':
      para = 'Outros';
      break;
    default:
      para = de;
      break;
  }
  if (!Object.keys(iconesMap).find(categoriaValida => categoriaValida === para))
    para = 'Outros';
  return para;
}
